import { render, staticRenderFns } from "./setPhone.vue?vue&type=template&id=5fe9f80b&scoped=true"
import script from "./setPhone.vue?vue&type=script&lang=js"
export * from "./setPhone.vue?vue&type=script&lang=js"
import style0 from "./setPhone.vue?vue&type=style&index=0&id=5fe9f80b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe9f80b",
  null
  
)

export default component.exports